import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, CssBaseline } from '@mui/material';
import AppHeader from '../ui/AppHeader';
import Sidebar from '../ui/Sidebar';

const SIDEBAR_STORAGE_KEY = 'sidebar:open';

const MainLayout: React.FC = () => {
  const [open, setOpen] = React.useState<boolean>(() => {
    const stored = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    // Por defecto el menú arranca expandido
    return stored === null ? true : stored === 'true';
  });

  const toggleDrawer = () => {
    setOpen((prev) => {
      const next = !prev;
      localStorage.setItem(SIDEBAR_STORAGE_KEY, String(next));
      return next;
    });
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CssBaseline />
      <AppHeader open={open} toggleDrawer={toggleDrawer} />
      <Sidebar open={open} />
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) => theme.palette.background.default,
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          pt: 8, // altura del AppBar
        }}
      >
        <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default MainLayout; 